
export const PAYPAL_ERROR_CONSTANTS = {
  RENDER_ERROR_NOTE: 'Failed to render Braintree PayPal button',
  RENDER_ERROR_SUB_EVENT_TYPE: 'BraintreeRenderError',
  RENDER_ERROR_DEFAULT_MESSAGE: 'Render failed',
  RENDER_ERROR_USER_MESSAGE: 'Failed to render PayPal button. Please refresh.',
  INIT_ERROR_NOTE: 'Braintree PayPal initialization error',
  INIT_ERROR_SUB_EVENT_TYPE: 'BraintreeInitError',
  INIT_ERROR_DEFAULT_MESSAGE: 'Initialization failed',
  INIT_ERROR_USER_MESSAGE: 'Paypal payment setup failed. Please refresh the page and try again.',
};
export const PAYPAL_CANCELLED_NOTE = 'User cancelled PayPal payment process';
export const PAYPAL_CANCELLED_SERVICE_URL = 'braintree-paypal-checkout';
export const PAYPAL_CANCELLED_EVENT_TYPE = 'FeInfo';
export const PAYPAL_CANCELLED_MESSAGE_TYPE = 'INFO';
export const PAYPAL_CANCELLED_MESSAGE = 'Payment cancelled by user';
export const PAYPAL_CANCELLED_SUB_EVENT_TYPE = 'PayPalCancelled';

export const PAYPAL_ERROR_NOTE = 'Braintree PayPal button error';
export const PAYPAL_ERROR_SERVICE_URL = 'braintree-paypal-checkout';
export const PAYPAL_ERROR_SUB_EVENT_TYPE = 'BraintreePayPalError';
export const PAYPAL_ERROR_DEFAULT_MESSAGE = 'PayPal button error';
export const PAYPAL_ERROR_USER_MESSAGE = 'PayPal button encountered an error. Please try again.';
/*
Failure reasons that are returned from withPieEncryption component from @vz-soe-utils/pieencryption package
 */
export const PIE_ENCRYPT_FAILURE_REASONS = {
  CHECKSUM_ERROR: 'CHECKSUM_ERROR',
  SCRIPT_ERROR_PCI: 'withPieEncryption::pieProtectPCI:: pie scripts are errored',
  SCRIPT_LOAD_ERROR_PCI: 'withPieEncryption::pieProtectPCI:: pie scripts are not loaded',
  SCRIPT_ERROR_SPI: 'withPieEncryption::pieProtectSPI:: pie scripts are errored',
  SCRIPT_LOAD_ERROR_SPI: 'withPieEncryption::pieProtectSPI:: pie scripts are not loaded',
};

/* Verbiage */
export const DEFAULT_ERR_MSG = 'We are unable to process the request at this time. Please try after sometime';

export const PAYMENT_APPROVE_PROCESSING_ERROR = 'Failed to process payment. Please try again.';

export const TOKENIZATION_FAILED = 'Tokenization failed';

export const BRAINTREE_TOKENIZE_ERROR =  'BraintreeTokenizeError';

export const BRAINTREE_PAYPAL_TOKENIZATION_ERROR = 'Braintree PayPal tokenization error';

export const BRAINTREE_PAYPAL_CHECKOUT = 'braintree-paypal-checkout';

export const ENABLE_BRAIN_TREE_PAYMENT_SESSION = 'enableBrainTreePaymentSession'

export const errors = {
  DT_OD_CHECKOUT_PAYMENT_PAN_CHECKSUM_ERROR:
    'The credit/debit card you submitted has been declined. Please choose another saved card or enter a new one.',
  DT_OD_CHECKOUT_PAYMENT_GC_ENCRYPTION_ERROR: 'The Gift Card Number or the PIN used is invalid.',
};

export const preFetchConsts = {
  SESSION_KEY: 'preFetch',
  QUERYSTRING_KEY: 'preFetch',
};

export const commonErrors = {
  defaultMessage: 'Looks like something went wrong. Please try again later.',
  invalidCaseError :
  "<p>Looks like a transaction was started on another device. Start a new transaction to continue.&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;<a class='transactionLink' onClick='window.redirectToHomePage()'> Start new order</a></p>",
  transactionExpired:
    '<p>Looks like a transaction was started on another device. Start a new transaction to continue.&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;<a id="transactionExpiryLink" className="transactionLink"> Start new order</a></p>',
  systemError: 'There is a problem with one of our systems. Please try again later.',
  plansPageRedirect: '<p>Plan is missing from cart. Please  <a href id="planLink"> choose a plan</a> to continue checkout</p>',
  invalidCaseErrorNotification :
  "<p>Looks like a transaction was started on another device. Start a new transaction to continue.</p>",
};

export const footerNotes = {
  JBLClip: 'Must maintain service in good standing for 65 days and redeem offer within 65 days of 7/30/25. (Or by 1/1/26 date.) If service is cancelled within 180 days, Verizon can charge back the Promotional Value ($79.99).',
  YTPremium: '$10/mo perk credit ends after 6 mos, if account does not stay in good standing or if service is moved to an ineligible plan during the 6-mo promo period. After 6 mos, perk bills as $10/mo unless perk is canceled or unregistered.',
  AmazonGC100: 'Must activate service within 14 days of purchase and maintain it in good standing for 45 days. Must redeem offer within 60 days of purchase. (Or by 8/24/25 whichever is first). If service is cancelled within 180 days, Verizon can charge back the Promotional Value ($150)',
  JBLPartyBox: 'Valid thru 7.30.25 for new Verizon Home Internet customers who install / maintain eligible services in good standing for 65 days & redeem w/in 60 days after, or by 1.1.26, whichever is first. Delivery may take 3-5 months after redemption.  One offer per Verizon account, while supplies last. Promo value charged back if service is canceled w/in 180 days. Restrictions apply.',
  AmazonGC250: 'Must activate service within 14 days of purchase and maintain it in good standing for 45 days. Must redeem offer within 60 days of purchase. (Or by 8/24/25 whichever is first). If service is cancelled within 180 days, Verizon can charge back the Promotional Value ($250)',
  samsung: 'Must maintain service in good standing and redeem offer w/in 30 days thereafter, or no later than 7.27.25, whichever is first. If service is canceled within 180 days, Verizon can charge back the Promotional Value ($400).',
}

export const CART_CONTACT_INFO_INTG = 'integratedCartContactInfo';

export const cradleThrottleValues = {
  CART_CONTACT_INFO_INTG_PASSKEY: 'cart-contactinfo-intg',
  CART_CONTACT_INFO_INTG_ENABLED: '|intgContactInfo|',
  CART_CONTACT_INFO_INTG_DISABLED: '|intg_C_ContactInfo|',
  CART_CONTACT_INFO_INTG_WHITELISTED: '|intgContactInfo-wl|',
  CART_CONTACT_INFO_INTG_BLACKLISTED: '|intg_C_ContactInfo-bl|',
  AUTOPAY_PREVIEW_ENABLED: 'autopay-preview',
  AUTOPAY_PREVIEW_DISABLED: 'autopay-C-preview',
};

export const PROGRESSIVE_PAGE = 'progressive';
export const wifiPlanIds = ["48120", "48224"];
export const wifiTransactionType = 'WIFIBACKUP';
export const appleOnePriceUpIds = ["2678"];
export const VHI_LITE_PLAN_ID = '64610';
export const VHI_LITE_EXTRA_PLAN_ID = '71464';
export const VHI_LITE_PLAN_NAME = 'Verizon Home Internet Lite';
export const WI_FI_Backup = 'Wi-Fi Backup';
export const APPLE_ONE_FAMILY_PERK_ID = '2679';
export const APPLE_ONE_INDIVIDUAL_PERK_ID = '2678';
export const APPLE_MUSIC_FAMILY_PERK_ID = '2677';
export const DISNEY_BUNDLE_PERK_ID = '3369';
export const MOVERS_PLAN_TYPE = {
  CURRENT: 'current',
  PREVIOUS: 'previous',
};

export const DYNAMIC_DISCOUNT_VALUE = '#DYNAMICLOYALTYDISCOUNT#';

export const LOYALTY_SED_OFFER_ID_FOR_THIRTY_SIX_MONTHS = ['3546', '3799', '3800', '3801'];
export const DISNEY_GOOGLE_AI_REQUIRED_SED_OFFER_IDS = ['480176', '476182'];

// Joint Transaction (JT) constants for pause/resume flows
export const JT_PROCESSING_MTN_KEY = 'jtProcessingMtn';
export const DEFAULT_PROCESSING_MTN = 'newLine1';
// Valid line param pattern: newLine followed by a number (e.g., newLine1, newLine2)
export const VALID_LINE_PARAM_PATTERN = /^newLine\d+$/;
